import { ComponentMetadata } from '@/common/components/types';
import { RouteToProductPage } from '@/modules/ProductPage/ProductPageConfig';
import { DisplateProductV2, GalleryItem } from 'generatedBfw/static';

import { AcronymType, ListingFunctionType, ListingType } from './gtm/types';
import { ComponentLocation } from './types/ComponentLocation.type';

export const mapItemToEventMessage = ({
  index,
  item,
  metadata,
}: {
  index: number;
  item: DisplateProductV2 | GalleryItem;
  metadata: ComponentMetadata;
}) => {
  return {
    message: {
      index,
      internalId: item.internalId,
      externalId: item.externalId,
      name: item.title,
      target: RouteToProductPage({ externalId: item.externalId.toString() }).route,
    },
    metadata,
  };
};

export const generateItemListId = (
  pageType: string,
  listingType: ListingType | ComponentLocation,
  listingFunction: ListingFunctionType | AcronymType,
): string => `PT:${pageType}|LT:${listingType}|LF:${listingFunction}`;
